var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.vehicles),function(vehicle){return (vehicle.vehicleTracking != null)?_c('here-info-bubble',{attrs:{"name":"test-bubble","lat":vehicle.vehicleTracking != null? vehicle.vehicleTracking.lat: 0,"lng":vehicle.vehicleTracking != null? vehicle.vehicleTracking.lng: 0,"component":_vm.vehicleInfoBubble,"data":{
        status: vehicle.status,
        registrationNumber: vehicle.registrationNumber,
        driverName: vehicle.driverName || 'Unknown',
        hardwareId: vehicle.trackingHardwareId,
        latitude: vehicle.vehicleTracking.lat,
        longitude: vehicle.vehicleTracking.lng,
        hasStreamingDevice: _vm.deviceList.includes(vehicle.mediaHardwareId),
        id: vehicle.id
    }}},[_c('here-marker',{key:vehicle.id,attrs:{"lat":vehicle.vehicleTracking != null? vehicle.vehicleTracking.lat: 0,"lng":vehicle.vehicleTracking != null? vehicle.vehicleTracking.lng: 0,"icon":{
                bitmap: _vm.icons[vehicle.status],
                options: { anchor: { x:15, y: 0 } }
            },"map":_vm.map,"animated-move":true,"is-on-click":""}})],1):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }